import React, { useEffect, useMemo, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useLocation } from "react-router";
import {
	ErrorDiagnostic2ReportApi,
	InfoAmountAndValueDiagnostic2ReportApi,
	InfoDiagnostic2ReportApi,
	InfoLayerDiagnostic2ReportApi,
} from "src/services/Api/Organization/types";
import { LoadingContainer } from "go-core/components/Loading";

interface Props {
	data?: InfoDiagnostic2ReportApi;
}
const OrganizationSettingsDiagnostic2LayersPage = (props: Props) => {
	const [layers, setLayers] = useState<Record<string, any>[] | undefined>(undefined);
	const [loading, setLoading] = useState<boolean>(true);
	const { search } = useLocation();
	const searchParams = useMemo(() => new URLSearchParams(search), [search]);
	const params = Object.fromEntries(searchParams);
	const productId = Number(params.product_id);

	const fetch = async (productId: number) => {
		if (params.only_error === undefined) params.only_error = "1";

		const flatLayers = props.data?.layers.filter((x: InfoLayerDiagnostic2ReportApi) => x.product_id === productId);
		const groups = [] as Record<string, any>[];
		flatLayers?.forEach((flatLayer: InfoLayerDiagnostic2ReportApi) => {
			let groupItem = groups.filter((x) => x.stock_id === flatLayer.stock_id)[0];
			if (groupItem === undefined) {
				const aav = props.data?.amount_and_values.filter(
					(x: InfoAmountAndValueDiagnostic2ReportApi) =>
						x.stock_id === flatLayer.stock_id && x.product_id === productId
				)[0];

				groupItem = {
					stock_id: flatLayer.stock_id,
					stock_name: flatLayer.stock_name,
					open_amount: aav ? aav.open_amount : undefined,
					open_value: aav ? aav.open_value : undefined,
					error: false,
					errors_amount: 0,
					products: [],
				};
				groups.push(groupItem);
			}
			const errorLength = flatLayer.errors.length;
			if (errorLength > 0) {
				groupItem.error = true;
				groupItem.errors_amount = groupItem.errors_amount + errorLength;
			}
			groupItem.products.push(flatLayer);
		});

		setLayers(groups);
		setLoading(false);
	};
	useEffect(() => {
		if (params.product_id !== undefined) {
			fetch(productId);
		}
	}, []);
	if (!productId) return <>Produkt nie istnieje</>;
	if (loading) return <LoadingContainer />;
	return (
		<div>
			{/*<SubmenuProductDiagnosticNavigation id={productId} />*/}
			<Tabs
				defaultActiveKey={layers !== undefined && layers?.length > 0 ? `nav_stock_${layers[0].stock_id}` : ""}
				id="diagnostic_stocks"
				className="mb-3"
			>
				{layers?.map((dataStock) => {
					return (
						<Tab
							style={{ color: "red" }}
							eventKey={`nav_stock_${dataStock.stock_id}`}
							title={
								<span className={`${dataStock.error ? "text-danger" : "text-warning"}`}>
									{`${dataStock.stock_name} `}
									<small>
										(ID: {dataStock.stock_id}, Q: {dataStock.products.length}, E:{" "}
										{dataStock.errors_amount})
									</small>
								</span>
							}
							key={dataStock.stock_id}
						>
							<div>
								<div className={`card card-body`}>
									Ilość: {dataStock.open_amount}, Wartość: {dataStock.open_value}
								</div>
								<table className="table">
									<thead>
										<tr>
											<th>Layer id / data</th>
											<th>Produkt</th>
											{/*<th>Typ dokumentu</th>*/}
											<th>Errory</th>
											<th>Ilości (aktualna, jaka powinna, różnica)</th>
										</tr>
									</thead>
									<tbody>
										{dataStock.products.map((dataStockProduct: Record<string, any>) => {
											const diffOpenAmount =
												dataStockProduct.open_amount - dataStockProduct.items_amount;
											const diffOpenValue =
												dataStockProduct.open_value - dataStockProduct.items_value;
											return (
												<tr key={dataStockProduct.layer_id}>
													<td>
														{dataStockProduct.date}
														{" | "}
														{dataStockProduct.layer_id}
													</td>
													<td>{dataStockProduct.product_name}</td>
													{/*<td>{dataStockProduct.document_type}</td>*/}
													<td>
														{dataStockProduct.errors.map(
															(error: ErrorDiagnostic2ReportApi) => {
																return (
																	<p
																		key={error.message}
																		className={`text-${
																			error.level === "ERROR"
																				? "danger"
																				: "warning"
																		}`}
																	>
																		{error.type}
																		{/*{error}*/}
																		{/*<small>{error.type}</small>*/}
																		{/*<br />*/}
																		{/*{error.message}*/}
																	</p>
																);
															}
														)}
													</td>
													<td>
														<p className={`p-0 m-0`}>
															Otwarta ilość:{" "}
															{diffOpenAmount !== 0 && (
																<>
																	<strong className={"text-danger"}>
																		{diffOpenAmount.toFixed(5)}
																	</strong>
																	{" / "}
																</>
															)}
															Layer: {dataStockProduct.open_amount} / Layer items:{" "}
															{dataStockProduct.items_amount}
														</p>
														<p className={"m-0"}>
															Otwarta wartość:{" "}
															{diffOpenValue !== 0 && (
																<>
																	<strong className={"text-danger"}>
																		{diffOpenValue.toFixed(2)}
																	</strong>
																	{" / "}
																</>
															)}
															Layer: {dataStockProduct.open_value} / Layer items:{" "}
															{dataStockProduct.items_value}
														</p>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						</Tab>
					);
				})}
			</Tabs>
		</div>
	);
};

export default OrganizationSettingsDiagnostic2LayersPage;
